module.exports = __webpack_public_path__ + "media/images/lla-logo--white-bfe3c6c383df83cfff4e5496b09f08b8.svg";